import PropTypes from 'prop-types';
import Dotdotdot from 'react-dotdotdot';
import styled from 'styled-components';

import { Box } from '@hivebrite/design-system/Box';

import { Link } from 'hb-react/frontoffice/components/Link';

const Attendee = ({ attendee }) => (
  <Box mt={6}>
    <Link to={Routes.user_path(attendee.id)}>
      <Box alignItems="center">
        <AvatarWrapper>
          <img src={attendee.photo_thumb_url} alt={attendee.name} />
        </AvatarWrapper>
        <Box flex={1} flexDirection="column">
          <Box font="h4-semibold">
            <Dotdotdot clamp={1} useNativeClamp>
              {attendee.name}
            </Dotdotdot>
          </Box>
          <Box font="metadata-regular-asphalt" mt={1}>
            <Dotdotdot clamp={1} useNativeClamp>
              {attendee.headline}
            </Dotdotdot>
          </Box>
        </Box>
      </Box>
    </Link>
  </Box>
);

Attendee.propTypes = {
  attendee: PropTypes.object.isRequired,
};

export default Attendee;

const AvatarWrapper = styled(Box).attrs(() => ({
  height: { _: 48, m: 60 },
  mr: 3,
  width: { _: 48, m: 60 },
}))`
  border-radius: 50%;
  user-select: none;

  img {
    border-radius: 50%;
    width: inherit;
  }
`;
